
/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime (time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
 export function hasClass (ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}
/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass (ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass (ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export const comMethod = {
  // 获取表格高度
  getTableHeight: (height) => {
    let tableheight = window.innerHeight - height
    tableheight = tableheight < 200 ? 200 : tableheight
    return tableheight
  },
  // 获取数组相optionKey匹配的optionValue值
  getDiceValue: (arr, key, optionKey = 'optionKey', optionValue = 'optionValue') => {
    let index = arr.findIndex(item => item[optionKey] === key)
    if (index > -1) {
      let text = arr[index][optionValue]
      text = text || text === 0 ? text : ''
      return text
    }
    return ''
  },
  // 根据参数拼接url地址
  getUrlStr: (data) => {
    let str = []
    for (let key in data) {
      str.push(`${key}=${data[key]}`)
    }
    return str.join('&')
  },
  // table转换成excel并下载
  tableToExcel: (outHtml, fileName) => {
    const worksheet = 'Sheet1'
    const uri = 'data:application/vnd.ms-excel;base64,'
    // 下载的表格模板数据
    const template = `<html xmlns:o="urn:schemas-microsoft-com:office:office" 
      xmlns:x="urn:schemas-microsoft-com:office:excel" 
      xmlns="http://www.w3.org/TR/REC-html40">
      <head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
      <x:Name>${worksheet}</x:Name>
      <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>
      </x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
      </head><body>${outHtml}</body></html>`
    // 下载模板
    let link = uri + comMethod.base64(template)
    let a = document.createElement('a')
    a.download = fileName + '.xls'
    a.href = link
    a.click()
  },
  base64: (s) => {
    return window.btoa(unescape(encodeURIComponent(s)))
  },
  // 字符串转换成数组
  strToArray (str) {
    return typeof (str) === 'string' && str ? str.split(',') : []
  },
  changeSelectNum (_num) {
    let num = (_num || 0) - 0
    num = num < 10 ? '0' + num : num
    return num
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js